// extracted by mini-css-extract-plugin
module.exports = {"page_header_location_container":"_bicM0cIp","page_header_location":"_ivAs-Jj_"};